import { jsx as _jsx } from "react/jsx-runtime";
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { Tooltip } from '@bluebeam/react-skyline-tooltip';
function InfoTooltip({ tooltip }) {
    return (_jsx(Tooltip, { label: tooltip, placement: "top", children: _jsx("span", { className: "relative ml-1 inline-block h-4 overflow-clip align-text-top text-black", children: _jsx(GeneralIcons.InfoIcon, { size: "16px" }) }) }));
}
export default InfoTooltip;
//# sourceMappingURL=InfoTooltip.js.map